<template>
  <div class="flex flex-col space-y-4">
    <b
      class="text-16px leading-18px"
      v-if="$delve(day, 'date') !== today">
      {{ $delve(day, 'date') }}
    </b>
    <div class="flex flex-col rounded-lg overflow-hidden divide-y">
      <div
        v-for="(notification, index) in payload"
        :key="index">
        <component
          :class="$classnames({
            'hover:bg-gray-100 cursor-pointer bg-catskill-white': notification.read === false,
          })"
          :payload="notification"
          :is="notification.component"
          @click.native="onClick(notification)"
          v-if="notification.component !== null"></component>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import ContractorRegisteredInInactiveRegion from '@/components/Notifications/ContractorRegisteredInInactiveRegion.vue';
import OrderCancelledByContractor from '@/components/Notifications/OrderCancelledByContractor.vue';
import OrderCancelledByCustomer from '@/components/Notifications/OrderCancelledByCustomer.vue';
import OrderGotPriority from '@/components/Notifications/OrderGotPriority.vue';
import OrderDisputed from '@/components/Notifications/OrderDisputed.vue';
import OrderChatMessage from '@/components/Notifications/OrderChatMessage.vue';
import { mapActions } from 'vuex';

export default {
  props: {
    day: {
      type: Object,
      required: true,
    },
  },
  components: {
    ContractorRegisteredInInactiveRegion,
    OrderCancelledByContractor,
    OrderCancelledByCustomer,
    OrderGotPriority,
    OrderDisputed,
    OrderChatMessage,
  },
  data() {
    return {
      today: moment().format('DD MMMM YYYY'),
      componentsMapping: {},
    };
  },
  computed: {
    payload() {
      return this.day.payload.map((obj) => {
        let key = this.$voca.capitalize(_.get(obj, 'type'));
        key = _.get(this.componentsMapping, key) || key;
        let component = null;
        if (Object.keys(this.$options.components).includes(key)) {
          component = this.$options.components[key];
        }
        return {
          ...obj,
          component,
        };
      });
    },
  },
  methods: {
    ...mapActions({
      read: 'notifications/ACT_READ_NOTIFICATION',
    }),
    onClick(event) {
      const { id, read } = event;
      if (read) {
        return null;
      }
      return this.read(id);
    },
  },
};
</script>
